import Controller, { OnBeforeFetch, OnBlur, OnChange, OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../BaseController';
import { Inject } from '@odinjs/odin';
import { Endpoint } from '../../../constants/endpoints';
import { HttpService, } from '@philips-internal/oswald-ui-core/lib/services';
import ShowToast from '../../../utils/toast-service';
import { ToastLevel } from '@philips-internal/oswald-ui-constants';
import { AutocompleteAPI, CheckboxAPI, FetchAPI, FieldAPI, ModalAPI, ModalService, PanelAPI } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import { CLINICAL_NOTES_MSG_COOKIE_KEY, ClinicalNotesMsgStatus } from '../clinical-note-service-constants';
import './clinical-notes-standard-text-controller.css';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { StandardText } from '../clinical-notes-types';
import { ClinicalNotesMyStandardTextAliases, FragmentNames } from '../../../codegen';

interface GroupStandardTextAutoCompleteProps {
  dsGroup: string;
  nrSeqGrupo: number;
}

interface StandardTextAutoCompleteProps {
  dsText: string;
  nrTextoPadrao: number;
}
@Controller({ component: ClinicalNotesMyStandardTextAliases.LAYOUT_STANDARD_TEXT, fragment: FragmentNames.CLINICAL_NOTES_MY_STANDARD_TEXT })
class ClinicalNotesStandardTextController extends BaseController {

  @Inject(ClinicalNotesMyStandardTextAliases.FETCH_STANDARD_TEXT)
  fecthStandardText!: FetchAPI;

  @Inject(ClinicalNotesMyStandardTextAliases.AUTOC_GROUP_STANDARD_TEXT)
  autocGroup!: AutocompleteAPI;

  @Inject(ClinicalNotesMyStandardTextAliases.AUTOC_STANDARD_TEXT)
  autocStandardText!: AutocompleteAPI;

  @Inject(ClinicalNotesMyStandardTextAliases.PANEL_MESSAGE_ACCEPT)
  panelMessageAcceptApi!: PanelAPI;

  @Inject(ClinicalNotesMyStandardTextAliases.PANEL_LOADER)
  panelLoaderApi!: PanelAPI;

  @Inject(ClinicalNotesMyStandardTextAliases.MODAL_STANDARD_TEXT)
  dialog!: ModalAPI;

  @Inject(ClinicalNotesMyStandardTextAliases.CHECKBOX_CLICNICAL_NOTES_MSG)
  checkbox!: CheckboxAPI;

  @Inject(ClinicalNotesMyStandardTextAliases.FIELD_CLICNICAL_NOTES_MSG)
  checkboxField!: FieldAPI;

  @Inject(ClinicalNotesMyStandardTextAliases.PANEL_ACCEPT)
  panelAcceptApi!: PanelAPI;

  @Inject(ClinicalNotesMyStandardTextAliases.PANEL_ACTIONS)
  panelActionsApi!: PanelAPI;

  encounterId!: number;
  patientId!: string;
  nrTextoPadrao = 0;
  nrSeqGrupo = 0;
  dsTextoReplaced = '';

  private showActionsLoadText(visible: boolean): void {
    this.panelLoaderApi.setVisible(!visible);
    this.panelMessageAcceptApi.setVisible(!visible);
    this.panelAcceptApi.setVisible(!visible);
    this.panelActionsApi.setVisible(visible);
  }

  private showActionsAccept(visible: boolean): void {
    this.panelLoaderApi.setVisible(!visible);
    this.panelMessageAcceptApi.setVisible(visible);
    this.panelAcceptApi.setVisible(visible);
    this.panelActionsApi.setVisible(!visible);
  }

  private close(): void {
    ModalService.close('clinical-notes-my-standard-text');
  }

  private getClinicalNotesMsgCookieValue(): string | undefined {
    const clinicalNotesMsgCookie = document.cookie.split(';').find(cookie => cookie.match(CLINICAL_NOTES_MSG_COOKIE_KEY));
    const clinicalNotesMsgCookieValue = clinicalNotesMsgCookie?.split('=')[1];
    return clinicalNotesMsgCookieValue;
  }

  private dispatchAddStandardTextEvent(): void {
    const event = new CustomEvent('addStandardText', { detail: this.dsTextoReplaced });
    dispatchEvent(event);
  }

  @OnChange('checkbox-clicnical-notes-msg')
  onChangeCheckBox(): void {
    this.checkbox.setValue(!this.checkbox.getValue())
  }

  @OnMount(ClinicalNotesMyStandardTextAliases.LAYOUT_STANDARD_TEXT)
  onMount(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();

    this.encounterId = encounterId as number;
    this.patientId = patientId as string;

    this.showActionsLoadText(true);

    this.context.set({
      nrSeqGrupo: 0
    });

  }

  @OnClick(ClinicalNotesMyStandardTextAliases.ACCEPT_CUSTOM_DYNAMIC_BUTTON)
  onButtonAcceptClick(): void {
    this.handleAcceptClick();
  }

  @OnClick(ClinicalNotesMyStandardTextAliases.STANDARD_TEXT_BUTTON_OK)
  onButtonOkClick(): void {
    this.handleOkClick();
  }

  @OnClick(ClinicalNotesMyStandardTextAliases.STANDARD_TEXT_BUTTON_CANCEL)
  onButtonCancelClick(): void {
    this.handleCancelClick();
  }

  @OnChange(ClinicalNotesMyStandardTextAliases.AUTOC_GROUP_STANDARD_TEXT)
  onGroupChange(event: ChangeEvent<GroupStandardTextAutoCompleteProps>): void {
    const { nrSeqGrupo } = event.value;

    this.context.set({
      nrSeqGrupo: nrSeqGrupo || 0,
    });

    this.showActionsLoadText(true);
  }

  @OnBlur(ClinicalNotesMyStandardTextAliases.AUTOC_GROUP_STANDARD_TEXT)
  onGroupBlur(): void {
    const value = this.autocGroup.getValue() as Record<string, Value>;

    if (!value || Number(value.nrSeqGrupo) === 0) {

      this.nrSeqGrupo = 0;

      this.context.set({
        nrSeqGrupo: 0
      });
    }
  }

  @OnBeforeFetch(ClinicalNotesMyStandardTextAliases.FETCH_STANDARD_TEXT)
  onStandardTextBeforeFetch(): void {
    this.autocStandardText.setValue({});
  }

  @OnChange(ClinicalNotesMyStandardTextAliases.AUTOC_STANDARD_TEXT)
  onTextChange(event: ChangeEvent<StandardTextAutoCompleteProps>): void {
    const { nrTextoPadrao } = event.value;

    this.nrTextoPadrao = nrTextoPadrao || 0;
    this.showActionsLoadText(true);
  }

  private handleCancelClick(): void {
    this.close();
  }

  private handleOkClick(): void {
    const cdPessoaFisica = this.patientId;
    const nrAtendimento = this.encounterId;
    const nrTextoPadrao = this.nrTextoPadrao;
    const standardTextType = 'MEDICAL';
    if (nrTextoPadrao && nrTextoPadrao > 0) {

      this.panelLoaderApi.setVisible(true);

      const showClinicalNotesMsg = !(this.getClinicalNotesMsgCookieValue() === ClinicalNotesMsgStatus.DEACTIVATED);

      HttpService.get<StandardText>(
        Endpoint.GET_NOTAS_CLINICAS_STANDARD_TEXT,
        { cdPessoaFisica, nrAtendimento, nrTextoPadrao, standardTextType }
      ).then(response => {
        const body = response.body as StandardText
        this.dsTextoReplaced = body.dsTexto;
        this.showActionsAccept(true);

        if (!showClinicalNotesMsg) {
          this.dispatchAddStandardTextEvent();
          this.close();
        }
      }).catch(err => {
        this.showActionsLoadText(true);
        ShowToast.open(err?.body.errorMessage, ToastLevel.ERROR);
        this.close();
      });
    }
  }

  private handleAcceptClick(): void {
    if (this.checkbox.getValue()) {
      document.cookie = `${CLINICAL_NOTES_MSG_COOKIE_KEY}=${ClinicalNotesMsgStatus.DEACTIVATED}`;
    }

    this.dispatchAddStandardTextEvent();

    this.close();
  }
}

export default ClinicalNotesStandardTextController;
